import {
    setCookie,
    getBrowser
} from '@/public/functions';

const getMainDomain = (url) => {
    var m = url.match(/^(http|https):\/\/[^/]+/); // remove https or https;
    return m ? m[0].replace(/(^\w+:|^)\/\//, '') : 'no value'; //select domain only;
}
const isCookieExists = (cookieName) => {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.indexOf(cookieName + '=') === 0) {
            return true;
        }
    }

    return false;
};



var searchEngines = [
    'google.com',
    'google.ca',
    'bing.com',
    'yahoo.com',
    'aol.com',
    'baidu.com',
    'ask.com',
    'excite.com',
    'duckduckgo.com',
    'wolframalpha.com',
    'yandex.com',
    'lycos.com',
    'chacha.com',
    'forums.ooma.com',
    'support.ooma.com',
];
var socials = [
    't.co',
    'facebook.com',
    'linkedin.com',
    'plus',
    'instagram.com',
    'reviews.com',
    'pinterest.com',
    'reddit.com',
    'tumblr.com',
    'snapchat.com',
    'flickr.com',
    'swarmapp.com'
];

const isReferrerOoma = () => {
    var getReferrer = getMainDomain(document.referrer);
    // console.log(getReferrer);
    var flag = false;
    var oomaDomains = [
        'ooma.com',
        'my.ooma.com',
        'office.ooma.com',
        'www.ooma.com',
        'ca.ooma.com',
        'www.ooma.ca',
        'voip-dev',
        'voip-dev-ca',
        'us-site',
        'ca-site',
        'forums-bboots',
        'dev-www.ooma.com',
        'devca-www.ooma.com'

    ];
    if ($.inArray(getReferrer, oomaDomains) !== -1) {
        flag = true;
    }
    return flag;
}

const arrchecker = (v, arr) => {
    let flag = false;
    for (let i = 0; i < arr.length; i++) {
        if (v !== null && v !== undefined && v.length > 0 && v.search(arr[i]) >= 0) {
            flag = true;
            break;
        }
    }
    return flag;
};


const getXYZreferrer = () => {
    let XYZreferrer = '';
    let XYZsource = '';
    //if referrer is false;
    if (document.referrer.length == 0) {
        XYZreferrer = 'Direct';
        XYZsource = 'Direct';
    }
    //if referrer is true and is the ooma.com domain;
    else {
        if (isReferrerOoma()) {
            XYZreferrer = 'Direct';
            XYZsource = 'Direct';
        }
        ////if referrer is true and is not ooma.com domain;
        else {
            XYZreferrer = getMainDomain(document.referrer);

            if (arrchecker(XYZreferrer, searchEngines)) {

                XYZsource = 'Organic';

            }
            if (arrchecker(XYZreferrer, socials)) {

                XYZsource = 'Social';
            }
            else {

                XYZsource = 'Direct';
            }

        }
    }
    return { 'XYZreferrer': XYZreferrer, 'XYZsource': XYZsource };
}




const currentBrowser = getBrowser().replace(/\s/g, "-").toLowerCase();
const trackNoCookieData = () => {
    let temp_utm_source = getXYZreferrer()['XYZsource'];
    let temp_referrer_url = getXYZreferrer()['XYZreferrer'];
    let temp_utm_campaign = '';
    let temp_utm_medium = '';
    // console.log(userData['programName']);
    let cookieStatus = navigator.cookieEnabled;
    let checkCookie = isCookieExists('XYZutm_source');

    //need to update for safari: True-NoSaved is not working on safari

    if (cookieStatus) {
        cookieStatus = 'True-Saved';
        if (!checkCookie) {
            cookieStatus = 'True-NoSaved';
        }
    }
    else {
        cookieStatus = 'False';
    }

    //if there is no cookie, check parameters:
    if (cookieStatus !== 'True-Saved') {
        console.log('step 1');
        const urlParams = new URLSearchParams(window.location.search);
        const params = {};

        for (const [key, value] of urlParams.entries()) {
            params[key] = value;
        }

        //get source

        if (typeof params['xutm_source'] !== 'undefined') {
            temp_utm_source = params['xutm_source']
        }
        else if (typeof params['utm_source'] !== 'undefined') {
            temp_utm_source = params['utm_source'];
        }

        //get campaign

        if (typeof params['xutm_campaign'] !== 'undefined') {
            temp_utm_campaign = params['xutm_campaign']
        }
        else if (typeof params['utm_campaign'] !== 'undefined') {
            temp_utm_campaign = params['utm_campaign'];
        }

        //get medium
        if (typeof params['xutm_medium'] !== 'undefined') {
            temp_utm_medium = params['xutm_medium'];
            temp_referrer_url = params['xutm_medium'];
        }
        else if (typeof params['utm_medium'] !== 'undefined') {
            temp_utm_medium = params['utm_medium'];
            temp_referrer_url = params['utm_medium'];
        }

        if (temp_utm_source.length > 1 && temp_utm_campaign.length > 1 && temp_utm_source !== 'Direct') {
            temp_referrer_url = `${temp_utm_source}__${temp_utm_campaign}`
        }


        //if cookie functionality turns on, re-save cookie:
        if (cookieStatus === 'True-NoSaved') {
            setCookie('XYZutm_source', temp_utm_source);
            setCookie('XYZutm_campaign', temp_utm_campaign);
            setCookie('XYZutm_medium', temp_utm_medium);
            setCookie('XYZreferrer', temp_referrer_url);
        }



    }

    return {
        'temp_utm_source': temp_utm_source,
        'temp_utm_campaign': temp_utm_campaign,
        'temp_utm_medium': temp_utm_medium,
        'temp_referrer_url': temp_referrer_url,
        'cookieStatus': cookieStatus
    }

}


export {
    trackNoCookieData
}